export default __webpack_public_path__ + "static/media/1_6.65b8a18c.png";